import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class RelativesMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.relatives.mapperError"));

        Object.setPrototypeOf(this, RelativesMapperError.prototype);
    }
}